import { takeLatest, put, call } from 'redux-saga/effects';
import * as correspondentTaskDetailsAction from './action';
import { CORE_API, REPORT } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_CONTENT_TYPE_FILE, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';


export function* fetchTasks(action) {
    let requestUrl = `${CORE_API}/correspondent/tasks/details/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(correspondentTaskDetailsAction.fetchTaskDetailsSuccess(listResult.data));
    } catch (err) {
        yield put(correspondentTaskDetailsAction.fetchTaskDetailsFailure(err))

    }
}
export function* fetchTasksDetails() {
    yield takeLatest(correspondentTaskDetailsAction.FETCH_TASK_DETAILS, fetchTasks);
}

export function* downloadAllTask(action) {
    let requestUrl = `${REPORT}/survey/tasks/downloadAll`;
    try {
        const listResult = yield call(request, requestUrl, { 
            data: action.data, 
            method: 'POST', 
            responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER,
            headers: HTTP_HEADERS });
        yield put(correspondentTaskDetailsAction.downloadAllTaskTemplateSuccess(listResult.data));
    } catch (err) {
        yield put(correspondentTaskDetailsAction.downloadAllTaskTemplateFailure(err))

    }
}
export function* downloadAllTaskDetails() {
    yield takeLatest(correspondentTaskDetailsAction.DOWNLOAD_ALL_TASK_TEMPLATE, downloadAllTask);
}

export function* downloadSingleTask(action) {
    let requestUrl = `${REPORT}`+action.data.url;
    try {
        const listResult = yield call(request, requestUrl, { 
            method: 'GET', 
            headers: HTTP_HEADERS_CONTENT_TYPE_FILE, 
            responseType: action.data.responseType });
        yield put(correspondentTaskDetailsAction.downloadTaskSuccess(listResult.data));
    } catch (err) {
        yield put(correspondentTaskDetailsAction.downloadTaskFailure(err))

    }
}
export function* downloadTask() {
    yield takeLatest(correspondentTaskDetailsAction.DOWNLOAD_TASK, downloadSingleTask);
}

export function* uploadSingleTask(action) {
    let requestUrl = `${REPORT}/survey/submit`;

    const formData = new FormData();
    formData.append('sectionTemplateId', action.data.sectionTemplateId);
    formData.append('reportRequestCaseId', action.data.reportRequestCaseId);
    formData.append('taskId', action.data.taskId);
    formData.append('counterpartyId', action.data.counterPartyId);
    formData.append('file', action.data.file);
    try {
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(correspondentTaskDetailsAction.uploadTaskSuccess(listResult));
        //yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })
    } catch (err) {
        yield put(correspondentTaskDetailsAction.uploadTaskFailure(err))
    }
}
export function* uploadTask() {
    yield takeLatest(correspondentTaskDetailsAction.UPLOAD_TASK, uploadSingleTask);
}